import React from "react"
//import I18n from "i18n-js/index.js.erb"

export default class EmailCampaignBuilderGeneral extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div>
        {this.renderNameAndCode()}
      </div>
    );
  };

  renderNameAndCode() {
    return(
      <div className="row" style={{ paddingLeft: 15 }} >
        <div className="col-md-2">
          <div className="form-group">
            <label>{`${I18n.t('code')}*`}</label>
            <input type="text" maxLength="12" className={this.fieldErrors('code') ? 'form-control has-errors': 'form-control'} name="code" value={this.props.email_campaign.code ? this.props.email_campaign.code : ''} onChange={this.props.onChange} />
            {
              this.fieldErrors('code')
            }
          </div>
        </div>
        <div className="col-md-3">
          <label>{`${I18n.t('name')}*`}</label>
          <div className="form-group">
            <input className={this.fieldErrors('name') ? 'form-control has-errors' : 'form-control'}  name="name" value={this.props.email_campaign.name ? this.props.email_campaign.name : ''} onChange={this.props.onChange} />
          {
           this.fieldErrors('name')
          }
          </div>
        </div>
      </div>
    );
  };

  fieldErrors(field){
    if (this.props.errors[field]) {
      return (
        <div className="help-block">
          <ul>{this.props.errors[field]}</ul>
        </div>
      )
    } else {
      return false
    }
  }
};
